import pdfMake from "pdfmake/build/pdfmake";
import pdfFormatPDOReport from "./pdfPDOReport";
import { TbPdf } from "react-icons/tb";
const pdfFonts = require("../../fonts/vfs_fonts");

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
  THSarabunNew: {
    normal: "THSarabunNew.ttf",
    bold: "THSarabunNew Bold.ttf",
    italics: "THSarabunNew Italic.ttf",
    bolditalics: "THSarabunNew BoldItalic.ttf",
  },
  Roboto: {
    normal: "Roboto-Regular.ttf",
    bold: "Roboto-Medium.ttf",
    italics: "Roboto-Italic.ttf",
    bolditalics: "Roboto-MediumItalic.ttf",
  },
};

const defaultFont = {
  font: "THSarabunNew",
};

function GeneratePdf(props: any) {
  const createPdf = () => {
    let pdfFormat = pdfFormatPDOReport({ ...props.data });
    const pdfGenerate = pdfMake.createPdf({
      ...pdfFormat,
      pageSize: "A4",
      defaultStyle: { ...defaultFont },
    } as any);
    if (props.type) {
      switch (props.type.toUpperCase()) {
        case "DOWNLOAD":
          pdfGenerate.download(`REPORT_${props.data.order.id}.pdf`);
          break;
        case "PRINT":
          pdfGenerate.print();
          break;
        default:
          pdfGenerate.open();
      }
    } else {
      pdfGenerate.open();
    }
  };

  return (
    <button
      className="flex items-center gap-1 btn-outline-danger"
      onClick={createPdf}
    >
      <TbPdf size={20} />
      Download PDF
    </button>
  );
}
export default GeneratePdf;
